<script setup lang="ts">
import WhatsappIcon from '~icons/girassol/whatsapp'
import ArrowRightIcon from '~icons/material-symbols/arrow-forward'

withDefaults(defineProps<{
  show: boolean
}>(), {
  show: false,
})

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'update'): void
}>()
const { t } = useI18n()

function openWhatsApp() {
  const whatsappLink = 'https://wa.me/5511912386374?text=Ol%C3%A1!%20Preciso%20de%20ajuda%20para%20atualizar%20meus%20dados%20banc%C3%A1rios%20na%20plataforma.'
  window.open(whatsappLink, '_blank')
}
</script>

<template>
  <div>
    <SolModal
      id="modal-update-bank"
      :is-open="show"
      :title="t('lack-bank.modal.title')"
      :size="{ desktop: 'medium', mobile: 'full' }"
      @close="emit('close')"
    >
      <template #action-primary>
        <SolButton id="btn-whatsapp" size="medium" @click="openWhatsApp">
          <template #icon:left>
            <img src="/icons/whatsapp-white.svg" class="w-5 h-4 mt-quark mr-quark" alt="whatsapp">
          </template>
          {{ t('lack-bank.modal.button') }}
        </SolButton>
      </template>
      <div class="flex flex-col items-start gap-7 self-stretch">
        <span class="text-neutral-low-medium fonts-body-medium-regular">
          {{ t('lack-bank.modal.subtitle') }}
        </span>

        <div class="flex flex-col item-start gap-2 w-full">
          <span class="fonts-body-medium-bold text-neutral-low-medium">
            {{ t('lack-bank.modal.whatsapp_description') }}
          </span>
          <div class="whatsapp-container">
            <div class="flex gap-2">
              <WhatsappIcon class="w-5 h-5 -mt-0.5" />
              <span class="fonts-body-medium-bold text-neutral-low-medium">
                {{ t('lack-bank.modal.contact.title') }}
              </span>
            </div>
            <button
              type="button"
              class="flex gap-2 cursor-pointer bg-transparent border-none p-0 text-left hover:opacity-80 transition-opacity"
              @click="openWhatsApp"
            >
              <span class="fonts-body-medium-bold text-brand-primary-dark underline">
                {{ t('lack-bank.modal.contact.whatsapp_number') }}
              </span>
              <ArrowRightIcon class="w-5 h-5 -mt-0.5" />
            </button>
          </div>
        </div>
        <div class="flex flex-col items-start gap-3">
          <span class="fonts-body-medium-bold text-neutral-low-medium">
            {{ t('lack-bank.modal.activate_account.title') }}
          </span>
          <ul class="activate-account-list">
            <li class="activate-account-item">
              <span v-html="t('lack-bank.modal.activate_account.items.title_1')" />
              <p class="fonts-body-medium-regular text-neutral-low-medium">
                {{ t('lack-bank.modal.activate_account.items.title_1_description') }}
              </p>
            </li>
            <li class="activate-account-item">
              <span v-html="t('lack-bank.modal.activate_account.items.title_2')" />
            </li>
          </ul>
        </div>
        <SolAlert
          id="alert-info"
          feedback="warning"
        >
          <p class="fonts-body-medium-regular text-neutral-low-medium">
            {{ t('lack-bank.modal.info_text') }}
          </p>
        </SolAlert>
      </div>
    </SolModal>
  </div>
</template>

<style scoped lang="scss">
.whatsapp-container {
  @apply flex p-4xs items-center justify-between gap-2 w-full;
  @apply border border-brand-primary-medium rounded-md bg-brand-secondary-light;
}

.activate-account-list {
  @apply flex flex-col items-start gap-2 list-disc pl-5;
}

.activate-account-item {
  @apply leading-xs;

  :deep(span) {
    @apply fonts-body-medium-regular text-neutral-low-medium;
  }
}
</style>
